module.exports = __webpack_public_path__ + "static/img/cont1405.c2bc1dc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/cont1405.jpg
// module id = OeJG
// module chunks = 0